module.exports = __webpack_public_path__ + "img/hr-boiler-W-idle.3be512dc.png";